import { useState, useEffect } from 'react'
import _ from 'lodash'

import Typography from '@mui/material/Typography'

import CustomTextField from '../common/wizard-custom-textfield'

const BusinessTitle = ({ setPrevButtonState, setNextButtonState, template, setTemplate, objectData, setObjectData }) => {

  const [titleValid, setTitleValid] = useState(true)
  const [headingValid, setHeadingValid] = useState(true)

  const setObjectValue = (path, value) => {
    let o = _.cloneDeep(objectData)
    _.set(o,path,value)
    setObjectData(o)
  }

  const setTemplateValue = (path, value) => {
    let t = _.cloneDeep(template)
    _.set(t,path,value)
  setTemplate(t)
  }

  useEffect(() => {
    setPrevButtonState("enabled")
    setNextButtonState("disabled")
  }, [])

  useEffect(() => {
    if(titleValid && headingValid) {
      setNextButtonState("enabled")
    } else {
      setNextButtonState("disabled")
    }
  }, [template])

  const setTitleValue = value => {
    setTemplateValue("meta.title", value)
    setObjectValue("cardTitle.defaultValue.value", value)
  }

  const setHeadingValue = value => {
    setTemplateValue("secondaryFields[0].value", value)
    setObjectValue("header.defaultValue.value", value)
  }

  const validateTitle = () => {
    const title = _.get(template, "meta.title")
    const isValid = title.length > 1
    setTitleValid(isValid)
  }

  const validateHeading = () => {
    const heading = _.get(template, "secondaryFields[0].value")
    const isValid = heading.length > 1
    setHeadingValid(isValid)
  }

  return (
    <>
      <Typography variant="h3" sx={{ p: 2 }}>Title & Heading</Typography>

      <CustomTextField label="Business Name" required={true} value={template.meta.title} onChange={setTitleValue} validate={validateTitle} valid={titleValid} helperText="Title text will appear at the top of the pass (unless you use a wide logo) and for Google passes it will show in your list of passes"/>
      <CustomTextField label="Title" required={true} value={template.secondaryFields[0].value} onChange={setHeadingValue} validate={validateHeading} valid={headingValid} helperText="Either enter a main heading for your pass, or use some simple instructions such as 'scan,download,add to contacts'"/>
    </>
  )
}

export default BusinessTitle

